import { render, staticRenderFns } from "./add-official-policy.vue?vue&type=template&id=0e773c24&scoped=true&"
import script from "./add-official-policy.vue?vue&type=script&lang=js&"
export * from "./add-official-policy.vue?vue&type=script&lang=js&"
import style0 from "./add-official-policy.vue?vue&type=style&index=0&id=0e773c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e773c24",
  null
  
)

export default component.exports